export var FAILED_IMPORTED_ERROR = 'Failed to fetch dynamically imported module';
